import { findMatchBetweenPlayers } from '../../utils/match'
import { formatDateTime } from '../../utils/format'
import { services } from '../../services'

export function getPlayerHomeCourt(playerId, roster = []) {
  const player = roster.find((p) => p.id === playerId)
  return player?.home_court || null
}

export function groupDoubleOpponents(opponents = []) {
  const pairs = []
  const seen = new Set()

  for (const player of opponents) {
    if (seen.has(player.id)) continue
    seen.add(player.id)

    const partnerId = player.partner?.partner_player_id
    if (!partnerId) {
      pairs.push([player])
      continue
    }

    const partnerPlayer = opponents.find(
      (candidate) => candidate.id === partnerId,
    )
    if (partnerPlayer && !seen.has(partnerId)) {
      seen.add(partnerId)
      pairs.push([player, partnerPlayer])
    } else {
      pairs.push([player])
    }
  }

  return pairs
}

export function getPendingProposals(proposals = []) {
  return proposals.filter(
    (proposal) => proposal.status === 'pending' && !proposal.is_sent_by_user,
  )
}

export function getOpponentGroups({ division, league }) {
  const isDoubles =
    division?.league_type === 'Doubles' || league?.league_type === 'Doubles'

  const myPartnerId = isDoubles
    ? (division?.roster || []).find(
        (player) => player.id === division?.player_id,
      )?.partner?.partner_player_id
    : null

  const opponents = (division?.roster || []).filter(
    (player) => player.id !== division?.player_id && player.id !== myPartnerId,
  )

  const opponentGroups = isDoubles
    ? groupDoubleOpponents(opponents)
    : opponents.map((player) => [player])

  return {
    isDoubles,
    myPartnerId,
    opponents,
    opponentGroups,
  }
}

export function getOpponentName(match, playerId) {
  try {
    return services.match.getOpponentName(match, playerId) || 'Opponent'
  } catch {
    return 'Opponent'
  }
}

export function formatMatchDateTime(datetime) {
  if (!datetime) return 'TBD'
  try {
    return formatDateTime(datetime)
  } catch {
    return String(datetime)
  }
}

export function getUnscheduledCount({ division, opponentGroups }) {
  const completedStatuses = new Set([
    'normal',
    'opponent_retired',
    'i_retired',
    'home_retired',
    'away_retired',
  ])

  return opponentGroups.reduce((count, group) => {
    const match = findMatchBetweenPlayers(
      division?.matches || [],
      division?.player_id,
      group[0].id,
    )

    if (!match) return count + 1
    if (match.status === 'scheduled') return count
    if (match.status === 'unplayed') return count
    if (completedStatuses.has(match.status)) return count

    return count + 1
  }, 0)
}
